import { render, staticRenderFns } from "./dashList.vue?vue&type=template&id=9cb136c0&scoped=true"
import script from "./dashList.vue?vue&type=script&lang=js"
export * from "./dashList.vue?vue&type=script&lang=js"
import style0 from "./dashList.vue?vue&type=style&index=0&id=9cb136c0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9cb136c0",
  null
  
)

export default component.exports